import { BrDivider, BrInput } from '@govbr-ds/react-components';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-dsgov';
import styles from './deducao.module.scss';
import { formatCurrency, removeFormatCurrency } from 'utils/formatCurrency';
import { ITributoAdicionado } from 'interfaces/ITributos';

interface IDeducaoProps {
  nome: string;
  isViewOnly: boolean;
  onChange: (nome: string, novoValor: number | '') => void;
  deducaoAdicionada: ITributoAdicionado | undefined;
  hideLabel?: boolean;
}
const Deducao = ({ nome, isViewOnly, onChange, deducaoAdicionada, hideLabel = false }: IDeducaoProps) => {
  const [valorDeducao, setValorDeducao] = useState(
    deducaoAdicionada?.valor ? formatCurrency(deducaoAdicionada?.valor) : ''
  );

  useEffect(() => {
    setValorDeducao(deducaoAdicionada?.valor !== undefined ? formatCurrency(deducaoAdicionada?.valor) : '');
  }, [deducaoAdicionada]);

  const onChangeValorDeducao = (novoValor: string): void => {
    setValorDeducao(novoValor);
    const valorNumerico = removeFormatCurrency(novoValor);
    onChange(nome, novoValor === '' ? '' : valorNumerico);
  };

  return (
    <div className={styles.container}>
      <Row>
        {hideLabel ? (
          ''
        ) : (
          <Col>
            <label className={styles.label}>{nome}</label>
          </Col>
        )}

        <Col className={styles.inputDeducao}>
          {isViewOnly ? (
            <span>{valorDeducao}</span>
          ) : (
            <BrInput
              autoComplete='off'
              numeric={{
                prefix: 'R$ ',
                thousandSeparator: '.',
                decimalScale: 2,
                fixedDecimalScale: false,
              }}
              className={styles.input}
              value={valorDeducao}
              onChange={(e) => onChangeValorDeducao(e.target.value)}
              data-testid={`input-valor-deducao-${nome}`}
            ></BrInput>
          )}
        </Col>
      </Row>
      {!hideLabel && <BrDivider className={styles.divider}></BrDivider>}
    </div>
  );
};

export default Deducao;
